import { useState, useEffect } from 'react'
import axios from 'axios'
import { Modal, message } from 'antd'
import MyInput from '../../components/forms/input'

const EditIngredient = (props) => {
  const [formValue, setFormValue] = useState({})
  const [errorMsg, setErrorMsg] = useState({})

  useEffect(() => {
    axios.post('/admin/content/basic_ingredient/detail/get', {
      basic_ingredient_oid: props.data.oid
    })
      .then(function (response) {
        if (response.errcode === 0) {
          setFormValue(response.data)
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }, [props.data])

  const handleOk = () => {
    setErrorMsg({})
    if (!formValue.name) {
      setErrorMsg({nameEmpty: '食材名称不能为空'})
      return false
    }

    axios.post('/admin/content/basic_ingredient/edit', { 
      basic_ingredient_oid: formValue.oid,
      name: formValue.name,
      calorie: Number(formValue.calorie),
      carbohydrate: Number(formValue.carbohydrate),
      protein: Number(formValue.protein),
      calcium: Number(formValue.calcium),
      potassium: Number(formValue.potassium),
      dietary_fiber: Number(formValue.dietary_fiber)
    })
      .then(function (response) {
        if (response.errcode === 0) {
          handleCancel()
          props.getIngredientData()
          message.success('修改成功！')
        } else if (response.errcode === 1) {
          setErrorMsg({ nameRepeatError: response.msg })
          return false
        } else {
          message.warning(response.msg)
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  const handleCancel = () => {
    setErrorMsg({})
    props.isCancel()
  }

  return (
    <Modal 
      title='添加食材'
      destroyOnClose={true}
      width='500px'
      open={props.isOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      cancelText="取消"
      okText="保存">

      <MyInput
        id="name"
        required
        autoFocus
        maxLength={64}
        label='食材名称'
        placeholder='请输入'
        value={formValue.name}
        onChange={setFormValue}
        errorMsg={errorMsg.nameEmpty || errorMsg.nameRepeatError}
      />

      <MyInput
        type='number'
        id="calorie"
        maxLength={64}
        label='热量(kcal)'
        value={formValue.calorie}
        onChange={setFormValue}
        styles={{ width: '100px' }}
        min={0}
        max={1000}
      />

      <MyInput
        type='number'
        id="carbohydrate"
        maxLength={64}
        label='碳水化合物(g)'
        value={formValue.carbohydrate}
        onChange={setFormValue}
        styles={{ width: '100px' }}
        min={0}
        max={1000}
      />

      <MyInput
        type='number'
        id="protein"
        maxLength={64}
        label='蛋白质(g)'
        value={formValue.protein}
        onChange={setFormValue}
        styles={{ width: '100px' }}
        min={0}
        max={1000}
      />

      <MyInput
        type='number'
        id="fat"
        maxLength={64}
        label='脂肪(g)'
        value={formValue.fat}
        onChange={setFormValue}
        styles={{ width: '100px' }}
        min={0}
        max={1000}
      />

      <MyInput
        type='number'
        id="moisture"
        maxLength={64}
        label='水分(g)'
        value={formValue.moisture}
        onChange={setFormValue}
        styles={{ width: '100px' }}
        min={0}
        max={1000}
      />

      <MyInput
        type='number'
        id="potassium"
        maxLength={64}
        label='钾(mg)'
        value={formValue.potassium}
        onChange={setFormValue}
        styles={{ width: '100px' }}
        min={0}
        max={1000}
        controls={false}
      />

      <MyInput
        type='number'
        id="sodium"
        maxLength={64}
        label='钠(mg)'
        value={formValue.sodium}
        onChange={setFormValue}
        styles={{ width: '100px' }}
        min={0}
        max={1000}
      />

      <MyInput
        type='number'
        id="calcium"
        maxLength={64}
        label='钙(mg)'
        value={formValue.calcium}
        onChange={setFormValue}
        styles={{ width: '100px' }}
        min={0}
        max={1000}
      />

      <MyInput
        type='number'
        id="magnesium"
        maxLength={64}
        label='镁(mg)'
        value={formValue.magnesium}
        onChange={setFormValue}
        styles={{ width: '100px' }}
        min={0}
        max={1000}
      />

      <MyInput
        type='number'
        id="iron"
        maxLength={64}
        label='铁(mg)'
        value={formValue.iron}
        onChange={setFormValue}
        styles={{ width: '100px' }}
        min={0}
        max={1000}
      />

      <MyInput
        type='number'
        id="phosphorus"
        maxLength={64}
        label='磷(mg)'
        value={formValue.phosphorus}
        onChange={setFormValue}
        styles={{ width: '100px' }}
        min={0}
        max={1000}
      />
    </Modal>
  )
}

export default EditIngredient
